/**
 * /strategy — redirect shim (#6232).
 *
 * The strategy surface is now: Documents on Assets → Documents, actions on
 * /optimizations → Actions, the report control on Business → Strategy, and
 * the report itself at /reports/strategy. Old links map to the closest home.
 */

import { createFileRoute, useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useSetAtom } from 'jotai';

import { selectedAssetsTabAtom, selectedBusinessTabAtom } from '@/store';

function StrategyRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const setBusinessTab = useSetAtom(selectedBusinessTabAtom);
  const setAssetsTab = useSetAtom(selectedAssetsTabAtom);

  useEffect(() => {
    const hash = location.hash.replace(/^#/, '');
    if (hash === 'actions') {
      navigate({ to: '/optimizations', hash: 'call-actions', replace: true, search: {} as never });
      return;
    }
    if (hash === 'calls') {
      setAssetsTab('documents');
      navigate({ to: '/assets', hash: 'documents', replace: true });
      return;
    }
    setBusinessTab('strategy');
    navigate({ to: '/business', hash: 'strategy', replace: true });
  }, [navigate, location.hash, setBusinessTab, setAssetsTab]);

  return null;
}

export const Route = createFileRoute('/_authenticated/_layout/strategy/')({
  component: StrategyRedirect,
});
